import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";
import type { TaxSubmissionDetailDTO } from "./TaxSubmissionDetailDTO";

interface useGetTaxSubmissionDetailProps {
    id: string;
}

export function useGetTaxSubmissionDetail(
    input: useGetTaxSubmissionDetailProps,
) {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders();
    const { t } = useTranslation();

    const query = useQuery<TaxSubmissionDetailDTO>({
        queryKey: ["useGetTaxSubmissionDetail", workspaceId, input.id],
        queryFn: async () => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/tax-submissions/${input.id}/details`,
                {
                    headers,
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        enabled: !!workspaceId && !!input.id,
        meta: {
            resourceName: t("errors.resourceName.taxSubmissionDetail"),
        },
    });

    return query;
}
